import { ServiceError } from "../../../../../../../service/Shared";
import { ActionButtons, Column, ErrorBox, Modal, Row } from "../../../../../../../widget";
import { useCompleteStageModal } from "./useCompleteStageModal";

export const CompleteStageModal = (): JSX.Element => {
  const { show, isHandleCompleteStageLoading, errors, handleClose, handleCompleteStage } = useCompleteStageModal();

  return (
    <Modal show={show} title="Complete stage?" onClose={handleClose} hasFullWidthTitle>
      {errors && errors.length > 0 && (
        <Row spacingV="ll">
          <Column offset={2} span={8}>
            <ErrorBox
              title="Please solve the below issues before saving"
              text={errors.map((error: ServiceError) => error.message)}
            />
          </Column>
        </Row>
      )}
      <form onSubmit={(e) => handleCompleteStage(e)}>
        <Row spacingV="xl" justify="center">
          <Column span={10}>
            <p className="body1">
              Marking this stage as complete will lock its steps and tasks. You won&apos;t be able to make changes after
              this.
            </p>
          </Column>
        </Row>
        <Row justify="center">
          <ActionButtons
            onCancel={handleClose}
            submitButtonLabel="Yes"
            isLoading={isHandleCompleteStageLoading}
            corners="rounded"
          />
        </Row>
      </form>
    </Modal>
  );
};
